import { useContext, useEffect, useState } from 'react';

import { postIncodeVerificationDocuments } from 'PrivateApis';

import { UserContext } from 'Context/user';
import { VehicleLookupContext } from 'Context/vehicleLookup';

import { INCODE_ANALYTICS } from '../IncodeAnalytics';
import { SENTRY_TAG } from '../IncodeSDKHelpers';

import { IncodeSessionState } from './useIncodeVerificationSession';

export const useEarlyDocsIncodeVerificationDocuments = () => {
  const { userState: user } = useContext(UserContext);
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  const [incodeSession, setIncodeSession] = useState<IncodeSessionState>(
    { session: undefined, success: undefined },
  );

  const { auth_token: authToken, dpSellerId, name, postcode } = user ?? {};
  const { dpEnquiryId } = vehicle?.enquiry ?? {};

  useEffect(() => {
    const abortController = new AbortController();

    if (!authToken || !dpEnquiryId) {
      setIncodeSession({ session: undefined, success: false });
      return () => {};
    }

    const payload = {
      address: user?.address1 ?? '',
      enquiryId: String(dpEnquiryId),
      mode: 'sdk',
      name,
      postcode,
      sellerId: String(dpSellerId),
      vrm: vehicle?.vrm,
    };

    postIncodeVerificationDocuments(
      { Authorization: authToken },
      payload,
      abortController,
    )
      .then((res) => {
        if (!res?.data?.session) {
          throw new Error('No incode session returned');
        }
        INCODE_ANALYTICS.INCODE_ADD_CONTEXT(res.data.session);
        setIncodeSession({ session: res.data.session, success: true });
      })
      .catch((err) => {
        globalThis?.Sentry?.captureException?.(err, SENTRY_TAG);
        setIncodeSession({ session: undefined, success: false });
      });

    return () => {
      abortController?.abort();
    };
  }, [authToken, dpEnquiryId, dpSellerId, name, postcode, user?.address1, vehicle?.vrm]);

  return { incodeSession };
};
